import { errorImage } from '@/globals/globals'
import { isImageFile } from '@/lib/isImageFIle'
import { Project } from '@/types/project'
import {
  AspectRatio,
  Box,
  Heading,
  Image,
  Link,
  LinkBox,
  LinkOverlay,
  Stack,
} from '@chakra-ui/react'
import NextLink from 'next/link'
import { UserAvatar } from './UserAvatar'
import { getPrefixedStorageURL } from '@/lib/getPrefixedStorageURL'

type Props = {
  project: Project
}

export const ProjectCard = ({ project }: Props) => {
  if (!project.published) return null

  let coverImage =
    project.images &&
    project.images.length > 0 &&
    isImageFile(project.images[0]?.pathImgkit)
      ? `${getPrefixedStorageURL(
          project.images[0]?.pathImgkit,
          'imgkit'
        )}?tr=n-project_card`
      : null

  if (!coverImage && project.videos && project.videos.length > 0) {
    coverImage =
      project.videos[0]?.thumbnail ||
      `https://img.youtube.com/vi/${project.videos[0]?.youtubeID}/maxresdefault.jpg`
  }

  if (!coverImage) {
    coverImage = errorImage
  }

  return (
    <LinkBox key={project.id} pos='relative'>
      <AspectRatio ratio={600 / 384} backgroundColor='blue.900'>
        <Image
          alt={project.title}
          height='384'
          objectFit='cover'
          objectPosition='center'
          src={coverImage}
          width='600'
        />
      </AspectRatio>
      {project.user?.garages &&
        project.user?.garages.length > 0 &&
        project.user.garages[0] && (
          <Box pos='absolute' top='2' right='2'>
            <NextLink
              href={`/nation/garages/${project.user.garages[0].slug}`}
              passHref
              legacyBehavior>
              <Link pos='relative'>
                <Stack direction='row'>
                  {project.user.garages[0].logo &&
                  project.user.garages[0].logo.length > 10 ? (
                    <Box p={1}>
                      <img
                        src={`${getPrefixedStorageURL(
                          project.user.garages[0].logo,
                          'imgkit'
                        )}?tr:h-84,cm-pad_resize')`}
                        alt={project.user.garages[0].title}
                        style={{
                          objectFit: 'contain',
                          objectPosition: 'center right',
                          height: '52px',
                          width: '120px',
                        }}
                      />
                    </Box>
                  ) : (
                    <Box
                      borderColor='white'
                      borderRadius='full'
                      borderWidth={2}
                      fontSize='xs'
                      width='52px'
                      height='52px'
                      textTransform='uppercase'>
                      <UserAvatar user={project.user} />
                    </Box>
                  )}
                </Stack>
              </Link>
            </NextLink>
          </Box>
        )}
      {project.videos && (
        <Box pos='absolute' bottom='4' right='4'>
          <img src='/img/icons/video.svg' alt='video' width='30' height='30' />
        </Box>
      )}
      <NextLink
        href={`/nation/projects/${project.slug}`}
        passHref
        legacyBehavior>
        <LinkOverlay
          opacity={0.75}
          _hover={{ opacity: '1' }}
          transitionDuration='1'
          transitionProperty='opacity'
          transitionTimingFunction='ease'>
          <Heading
            as='h2'
            fontSize='lg'
            mx={2}
            backgroundColor='blue.900'
            color='white'
            px={3}
            py={2}
            pos='absolute'
            bottom={1}
            left={-1}>
            {project.title}
          </Heading>
        </LinkOverlay>
      </NextLink>
    </LinkBox>
  )
}
